// extracted by mini-css-extract-plugin
export default {"tagsContainer":"index-module__X4qk6","newTag":"index-module__kyrTQ","tags":"index-module__Hjqgp"};